import React from 'react';
import { Country, State, LocalGovernmentArea } from '../../types/geography';

interface GeographySelectorFormProps {
  selectedContinent: string;
  countries: Country[];
  states: State[];
  lgas: LocalGovernmentArea[];
  selectedCountry: string;
  selectedState: string;
  selectedLga: string;
  onContinentChange: (value: string) => void;
  onCountryChange: (value: string) => void;
  onStateChange: (value: string) => void;
  onLgaChange: (value: string) => void;
}

const CONTINENTS = ['Africa', 'North America'];

const GeographySelectorForm: React.FC<GeographySelectorFormProps> = ({
  selectedContinent,
  countries,
  states,
  lgas,
  selectedCountry,
  selectedState,
  selectedLga,
  onContinentChange,
  onCountryChange,
  onStateChange,
  onLgaChange,
}) => {

  return (
    <div className="bg-gray-100 p-4 rounded-lg shadow-md mb-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Continent Selector */}
        <div>
          <label htmlFor="continent" className="block text-sm font-medium text-gray-700">Continent</label>
          <select 
            id="continent" 
            value={selectedContinent}
            onChange={(e) => onContinentChange(e.target.value)}
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md"
          >
            <option value="">Select Continent</option>
            {CONTINENTS.map(continent => (
              <option key={continent} value={continent}>{continent}</option>
            ))}
          </select>
        </div>

        {/* Country Selector */}
        <div>
          <label htmlFor="country" className="block text-sm font-medium text-gray-700">Country</label>
          <select 
            id="country" 
            value={selectedCountry} 
            onChange={(e) => onCountryChange(e.target.value)} 
            disabled={!selectedContinent}
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md disabled:bg-gray-200"
          >
            <option value="">Select Country</option>
            {countries.map(country => (
              <option key={country.id} value={country.id}>{country.name}</option>
            ))}
          </select>
        </div>

        {/* State/Province Selector */}
        <div>
          <label htmlFor="state" className="block text-sm font-medium text-gray-700">State/Province</label>
          <select id="state" value={selectedState} onChange={(e) => onStateChange(e.target.value)} disabled={!selectedCountry} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md disabled:bg-gray-200">
            <option value="">Select State</option>
            {states.map(state => (
              <option key={state.id} value={state.id}>{state.name}</option>
            ))}
          </select>
        </div>

        {/* LGA/City Selector */}
        <div>
          <label htmlFor="lga" className="block text-sm font-medium text-gray-700">LGA/City</label>
          <select id="lga" value={selectedLga} onChange={(e) => onLgaChange(e.target.value)} disabled={!selectedState} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md disabled:bg-gray-200">
            <option value="">Select LGA</option>
            {lgas.map(lga => (
              <option key={lga.id} value={lga.id}>{lga.name}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default GeographySelectorForm;
